module.exports = __webpack_public_path__ + "static/media/designPatent_2.61c047ae.png";